import { render, staticRenderFns } from "./RowBlockBuyingHomeInsurance.vue?vue&type=template&id=08286c69&"
import script from "./RowBlockBuyingHomeInsurance.vue?vue&type=script&lang=js&"
export * from "./RowBlockBuyingHomeInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports